import { create as a } from "zustand";
import { persist as r, createJSONStorage as s } from "zustand/middleware";
const l = "en-gb", i = a()(
  r(
    (e) => ({
      locale: l,
      translations: {},
      setLocale: (o) => {
        const t = o.toLowerCase();
        e(() => ({
          locale: t
        }));
      },
      setTranslations: (o) => e(() => ({ translations: o }))
    }),
    {
      name: "intl-storage",
      storage: s(() => localStorage)
    }
  )
);
export {
  i as useIntlStore
};
